export default {
  props: {},
  data() {

  },
  computed: {},
  watch: {},
  methods: {
    getCookie: function (name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    },
    setCookie: function (name, value, hours = 1) {
      let date = new Date();
      date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
      let expires = '; expires=' + date.toUTCString();
      document.cookie = name + '=' + (value || '') + expires + '; path=/';
    },
  },
  mounted() {

  },
};
